<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        eventTable(:eventType="eventType" v-if="stage === 'eventList'")
        MultiFlow(
          v-if="stage === 'setFlowData'"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          v-on:setAllConfirmData="getAllConfirmData"
        )
        Loader(v-if="stage === 'finish'")
      
    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel")
      action-button(title="取消全選" slot="button-6" @click.native="$store.dispatch('unSelectAllEventItems')" v-if="stage !== 'setFlowData'")
      action-button(title="選擇全部" slot="button-7" @click.native="$store.dispatch('selectAllEventItems')" v-if="stage !== 'setFlowData'" )
      action-button(
        title="開始動作" slot="button-9" @click.native="startFlow" 
        v-if="stage !== 'setFlowData'" 
        :clickable="$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || $store.state.event.selectedEventId.length > 0")

</template>

<script>
import progressBar from './flowComp/ProgressBar';
import eventTable from './flowComp/EventTable';
import AppBase from './ComponentBase/AppBase';
import MultiFlow from './RecycleEmptyFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';

export default {
  name: 'ReturnEmpty',
  extends: AppBase,
  data() {
    return {
      eventType: 'RETURN_EMPTY',
      stage: '',
    };
  },
  components: {
    progressBar,
    eventTable,
    BottomButtons,
    MultiFlow,
  },
  created() {
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    this.stage = 'eventList';
  },
  methods: {
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RECYCLE_EMPTY' });
      this.$router.push({ name: 'Main' });
    },
    setupProgress() {
      const prog = [];
      prog.push({ en: 'selectEvent', zh: '選擇事件' });
      // prog.push({ en: 'setStorage', zh: '空瓶交換數量' });
      prog.push({ en: 'action', zh: '開始動作' });
      return prog;
    },
    setupMultiProgress() {
      const prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    setupConfirmProgress() {
      const prog = [];
      // prog.push('setStorage');
      prog.push('action');
      return prog;
    },
    setupActionProgress() {
      const prog = [];
      prog.push('action');
      prog.push('next');
      return prog;
    },
    startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'eventList';
      this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    },
  },
};
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// RecycleEmpty.vue?3524c782